import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const McMasterUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="McMaster University"
      universityShortName="McMaster"
      slug="mcmaster-university"
      seoTitle="McMaster University Study Rooms | Hamilton Campus Study Guide"
      seoDescription="Complete guide to study rooms at McMaster University. Find Mills Library, Thode Library, and designated study zones. Plus free 24/7 online alternative."
      seoKeywords="mcmaster study rooms, mcmaster library, mills library, thode library, hamilton university study spaces"
      canonicalUrl="/study-room/mcmaster-university/"
      heroDescription="A comprehensive guide to study rooms and spaces at McMaster, including Mills and Thode Libraries with designated noise zones."
      libraryWebsiteUrl="https://library.mcmaster.ca/"
      libraryWebsiteName="McMaster Library"
      studySpaces={[
        {
          name: "Mills Library - Group Study Zones",
          features: "Group study areas and bookable rooms L310 A-E overlooking the Learning Commons.",
          feedback: "Group rooms fill up quickly; acoustics make even small whispers carry."
        },
        {
          name: "Mills Library - Quiet Study Zones",
          features: "Various floors with carrels and comfortable chairs for quieter work.",
          feedback: "Good for individual study; top floor has large windows for natural light."
        },
        {
          name: "Thode Library - Silent Study Rooms",
          features: "Rooms requiring complete silence with individual desks.",
          feedback: "Perfect for exam prep; strictly enforced silence policy."
        },
        {
          name: "Learning Commons",
          features: "Collaborative space visible from group study rooms above.",
          feedback: "Active and social; good for group projects."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Book group rooms early if you need collaborative space. For exam prep, head to <strong>Thode's silent study rooms</strong>.
          </p>
          <p className="mb-4">
            If you prefer natural light, the <strong>top floor of Mills</strong> has large windows. Remember to bring your own dry-erase markers for whiteboards.
          </p>
          <p>
            Students appreciate the ability to report noise via email and the variety of spaces available.
          </p>
        </>
      }
      summaryTips={[
        "Book Mills group rooms early: Rooms L310 A-E are popular and fill quickly.",
        "Use Thode for silent study: Strictly enforced silence perfect for exam prep.",
        "Head to Mills' top floor: Large windows provide great natural light.",
        "Bring dry-erase markers: Essential for using whiteboards in group rooms.",
        "Use CSW when rooms are full: Virtual study rooms offer unlimited availability."
      ]}
    />
  );
};

export default McMasterUniversity;
